import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody, Button, Form, Input, ModalHeader,
  FormGroup, Label, ButtonGroup,
} from 'reactstrap';
import { useForm } from 'react-hook-form';
import { useMutation } from 'react-apollo';
import { useToasts } from 'react-toast-notifications';
import * as _ from 'lodash';
import firebase from 'firebase';
import InputError from '../shared/elments/InputError';
import {
  LOGO_LARGE_BLACK, staticConstants, NUMERIC_VALUE, handleGraphqlError, getLocalUserData,
} from '../../utils';
import { CHANGE_PASSWORD, LOADER_MUTATION } from '../../graphql-client/mutations';
import { firebaseAuth } from '../../config/firebase';

function ChangePassword(props) {
  const {
    register, handleSubmit, errors, watch,
  } = useForm({ mode: 'onblur' });
  const { addToast } = useToasts();
  const {
    isOpen, onClose,
  } = props;

  const [modal, setModal] = useState(isOpen);
  const toggle = () => {
    setModal(!modal);
    onClose();
  };
  const [apiData, setApiData] = useState();

  const [loader] = useMutation(LOADER_MUTATION, {
    variables: {},
  });
  const [changePassword] = useMutation(CHANGE_PASSWORD, {
    variables: apiData,

    onError(error) {
      loader({ variables: { show: false } });
      addToast(handleGraphqlError(error), { appearance: 'error' });
    },

    onCompleted: async (data) => {
      try {
        loader({ variables: { show: false } });
        const userData = getLocalUserData();
        const credential = await firebase.auth.EmailAuthProvider.credential(userData.email, apiData.oldPassword);
        await firebaseAuth.currentUser.reauthenticateWithCredential(credential);
        await firebaseAuth.currentUser.updatePassword(apiData.confirmPassword);
        addToast(data.changePassword.message, { appearance: 'success' });
        props.onClose();
      } catch (err) {
        console.log({ err });
      }
    },
  });
  /* ---- end Register mutation ----*/

  const onSubmit = (data) => {
    setApiData(_.pick(data, ['oldPassword', 'confirmPassword']));
    loader({ variables: { show: true } });
    changePassword();
  };

  return (
    <Modal isOpen={modal} toggle={toggle} className="modal-signup modal-change-password">
      <ModalHeader toggle={toggle} className="modal-blank-header" />
      <ModalBody>
        <div className="forgot-password-wrapper change-password">
          <div className="form-container">
            <div className="forgot-password-logo">
              <img src={LOGO_LARGE_BLACK} alt="BYGmusic" />
            </div>
            <h2>Change password</h2>
            <p>Type in your current and new password to update your password.</p>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <FormGroup className={errors.oldPassword ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
                <Label
                  for="oldPassword"
                >
                  Current password
                </Label>
                <Input
                  type="text"
                  name="oldPassword"
                  autoComplete="off"
                  placeholder="Enter current password"
                  innerRef={register({
                    required: true,
                    maxLength: NUMERIC_VALUE.TWENTY,
                    minLength: NUMERIC_VALUE.EIGHT,
                  })}
                />
                <InputError error={errors.oldPassword} max={NUMERIC_VALUE.TWENTY} min={NUMERIC_VALUE.EIGHT} />
              </FormGroup>
              <FormGroup className={errors.newPassword ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
                <Label
                  for="newPassword"
                >
                  New password (Min 8 characters)
                </Label>
                <Input
                  type="password"
                  name="newPassword"
                  placeholder="Enter new password"
                  autoComplete="off"
                  innerRef={register({
                    required: true,
                    maxLength: NUMERIC_VALUE.TWENTY,
                    minLength: NUMERIC_VALUE.EIGHT,
                  })}
                />
                <InputError error={errors.newPassword} max={NUMERIC_VALUE.TWENTY} min={NUMERIC_VALUE.EIGHT} />
              </FormGroup>
              <FormGroup className={errors.confirmPassword ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
                <Label
                  for="confirmPassword"
                >
                  Confirm password
                </Label>
                <Input
                  type="password"
                  name="confirmPassword"
                  placeholder="Enter confirm password"
                  autoComplete="off"
                  innerRef={register({
                    required: true,
                    validate: {
                      confirmPassword: (value) => value === watch('newPassword'),
                    },
                  })}
                />
                <InputError error={errors.confirmPassword} max={NUMERIC_VALUE.TWENTY} min={NUMERIC_VALUE.EIGHT} />
              </FormGroup>

              <ButtonGroup className="justify-content-center">
                <Button
                  color="primary"
                  className="btn-md"
                  element="inlineBlock"
                  type="submit"
                >
                  Save
                </Button>
              </ButtonGroup>
            </Form>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}
ChangePassword.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default ChangePassword;
